export default {
  area1: {
    h2: `Move past the “friend zone” without the fear of rejection`,
    h3: `Don’t spend another day wondering ‘what if.’ Discover mutual romantic feelings with the friend, co-worker, classmate, or other acquaintance you’ve been crushing on—easily and anonymously!`,
    buttonLabel: `Get started`
  },
  area2: {
    title: "How it works",
    step1: {
      h1: `STEP 1: PLEDGE YOUR LOVE`,
      h2: `Make a $10 pledge to the charity of your choice. Why? We want to ensure you’re serious about your feelings. (Note: Your credit card is only charged if a mutual match is made.)`
    },
    step2: {
      h1: `STEP 2: SEND YOUR LOVE`,
      h2: `Enter your crush’s email or phone number and a hint about yourself. We’ll deliver the anonymous message that someone really, really likes them!`
    },
    step3: {
      h1: `STEP 3: FALL IN LOVE`,
      h2: `Your crush is prompted to enter who they have feelings for. If it’s you and a match is made, well… we’ll go ahead and wait for our wedding invitation. (We require them to make a pledge, too, to ensure their feelings are as strong as yours.)`
    }
  },
  area3: {
    h1: `100% RISK-FREE GUARANTEE`,
    h3: `You have nothing to lose and everything to gain. No match? Pay $0. But if there is a match? $10 can get you a life partner who thinks all those “quirky habits” you have are actually really cute!`
  },
  area4: {
    h1: `TRUSTED AND SECURE`,
    h3: `If a match is made, pledges will be processed by leading donation management firm PandaPay. If no match occurs within 30 days, we delete your information and your pledge is voided.`
  },
  area5: {
    h1: `LOVE IS THE MISSION`,
    h3: `This may sound cheesy, but we truly believe love makes the world a better place. That’s why we set out to create a process that combines positive interactions, shame-free matching, and giving back.`
  },
  area6: {
    h1: `Proud Sponsor`,
    note: `We deduct 3% from the donation if there’s a match and the transaction is processed. This minimal amount is used to keep the office lights on, the site running, and other business functions operating. We pledge to donate any 2019 profits to these two charities.`
  }
};



// WEBPACK FOOTER //
// ./assets/strings/home.js